import React, { FunctionComponent } from 'react';
import HvSvg from 'src/components/HvSvg';
import { useService } from '@xstate/react';
import { NotificationContext } from 'src/machines/notificationMachine';
// TODO: update webpack / typescript config so that these svg file
// imports are recognized properly
// @ts-ignore
import errorIcon from 'src/assets/icons/error-logo.svg';
// @ts-ignore
import successIcon from 'src/assets/icons/checkmark.svg';
import {
  NotificationContainer,
  NotificationComponentContainer,
  IconContainer,
} from './styled';

interface NotificationProps {
  notifierMachineRef: any;
}

interface AlertType {
  icon: string;
  color: string;
}
const notificationConfig: { [key: string]: AlertType } = {
  success: { icon: successIcon, color: 'green' },
  error: { icon: errorIcon, color: 'red' },
};

const NotificationNew: FunctionComponent<NotificationProps> = (props) => {
  const { notifierMachineRef } = props;
  const [state] = useService(notifierMachineRef);
  const { notification } = state.context as NotificationContext;
  const alertType = notification?.type || 'success';
  const { icon, color } = notificationConfig[alertType];

  return (
    <NotificationContainer isVisible={notification?.isVisible}>
      <NotificationComponentContainer>
        <IconContainer color={color}>
          <HvSvg src={icon} disabled={false} />
        </IconContainer>
        {notification?.message}
      </NotificationComponentContainer>
    </NotificationContainer>
  );
};

export default NotificationNew;
